import React from 'react';
import './ProgressBar.css';

function ProgressBar({ progress }) {
    return (
        <div className="progress-bar-container">
            <div className="progress-bar">
                <div
                    className="progress-filled"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
}

export default ProgressBar;
